<template>
    <b-overlay :show="this.is_load" rounded="sm">
        <button type="button" class="btn btn-lg  waves-effect waves-themed w-100 mb-3" :class="cur_class" v-on:click="make_action">
            <span class="fal fa-check mr-1"></span>
            {{__t(butt_title)}}
        </button>

        <div class="hook_data mt-5" v-if="location_hook_item">



            <div class="d-flex flex-row align-items-center p-2">
                <div class="icon-stack display-3 flex-shrink-0">
                    <i class="fal fa-circle icon-stack-3x opacity-100 color-primary-400"></i>
                    <i class="fas fa-address-book icon-stack-1x opacity-100 color-primary-500"></i>
                </div>

                <div class="ml-3 w-100">
                    <strong>
                        <div class="badge badge-success">
                            {{location_hook_item.added}}
                        </div>
                    </strong>


                    <div id="panel-3" class="panel panel-collapsed mt-2">
                        <div class="panel-hdr color-success-600">
                            <h2>
                                Log <span class="fw-300"><i></i></span>
                            </h2>
                            <div class="panel-toolbar">
                                <button class="btn btn-panel waves-effect waves-themed"
                                        data-action="panel-collapse"
                                        data-toggle="tooltip" data-offset="0,10" data-original-title="Collapse">
                                </button>
                            </div>
                        </div>

                        <div class="panel-container collapse" style="width: 100%">
                            <div class="panel-content">
                                <div>
                                    <small>
                                        {{location_hook_item.provider_data}}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </b-overlay>
</template>

<script>
export default {
    name: "shopify_hook",

    props : {
        location : {
            type : Object
        }
    },

    created() {
        this.load_hook();
    },

    data () {
        return {
            is_load : false,
            hook_data : {
                is_hook_added  :false,
            },
        }
    },

    methods : {

        async make_action() {
            this.is_load = true;
            agr_api.patch('/aggregators/locations/shopify/' + this.location.id + '/hook').then(({data}) => {
                if (data.status === "operation_success") {
                    this.is_load = false;
                    this.load_hook();
                }
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                })
            });
        },

        async load_hook() {
            this.is_load = true;
            agr_api.get('/aggregators/locations/shopify/' + this.location.id + '/hook').then(({data}) => {
                if (data.status === "operation_success") {
                    this.hook_data = data.data;
                    this.is_load = false;
                }
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                })
            });
        }
    },

    computed : {
        is_on() {
            if(this.hook_data.hasOwnProperty("is_hook_added")) {
                return this.hook_data.is_hook_added;
            }
        },

        location_hook_item() {
            if(this.is_on) {
                if(this.hook_data.hasOwnProperty("location_webhook")) {
                    return this.hook_data.location_webhook;
                }
            }

            return null;
        },

        cur_class () {
            if(this.is_on) {
                return "btn-danger"
            }
            return "btn-success"
        },

        butt_title() {
            if(this.is_on) {
                return "REMOVE_HOOK";
            }

            return "ADD_HOOK"
        }
    }
}
</script>

<style scoped>

</style>
